export default __webpack_public_path__ + "static/media/tf-logo.e58c9833.svg";